import tippy from './tippy.js';
import { debounce } from './throttle-debounce';
import scss from 'scss';

export default class Tooltips {
    constructor() {
        this.dom = {
            $: window.$,
            jQuery: window.$,
            $window: $(window),
            $body: $('body'),
            $trigger: $('.tooltip-trigger')
        };

        this.instances = [];

        this.init();
    }

    init() {
        this.appendTooltips();
        this.events();
        this.onResizeCallback();
    }

    appendTooltips() {
        let that = this;
        this.dom.$trigger.each((_, tt) => {
            let instance = tippy(tt, {
                trigger: ($(tt).data('trigger') || 'mouseenter'),
                theme: 'light-border',
                placement: 'top',
                arrow: true,
                offset: '0, 0',
                content: this.getHtml(tt),
                delay: 100,
                async onShow(instance) {
                    if ($('.tooltip-trigger.tippy-active').length > 0) $('.tooltip-trigger.tippy-active')[0]._tippy.hide();
                }
            });

            this.instances.push(instance);

            $(tt).on('mouseover', function () {
                instance.setContent(that.getHtml(tt));
            });
        });
    }

    getHtml(item) {
        let $layout = $('<div />').attr({
            class: 'tooltip-content'
        }).html(`
            <a href="#" class="tooltip-close">X</a>
            <div>${$(item).data('content')}</div>
        `);

        return $layout[0];
    }

    onResizeCallback() {
        this.instances.forEach((instance) => {
            if ($('.spike').length == 0 && this.dom.$window.width() < parseInt(scss['$very-lg'])) {
                instance.set({
                    placement: 'right',
                    offset: '10, 20'
                });
            }
        });
    }

    events() {
        this.dom.$body.on('click', '.tooltip-close', (e) => {
            e.preventDefault();
            if ($('.tooltip-trigger.tippy-active').length > 0) $('.tooltip-trigger.tippy-active')[0]._tippy.hide();
        });

        this.dom.$window.on('resize', debounce(200, this.onResizeCallback.bind(this)));
    }
}
